import DropdownIndicator from "components/common/ReactSelectDropdownIndicator";
import Option from "components/common/ReactSelectOption";

export default {
  DropdownIndicator,
  Option,
  IndicatorSeparator: null,
};
